import React from "react";
import { useSEO } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageBits";
import LeadForm from "@/components/LeadForm";
import { Clock, ShieldCheck, Headset } from "lucide-react";

export default function Quote() {
  useSEO({ title: "Request a Quote", description: "Request a wholesale tea powder quote from Leaf Alchemy. Fast response, competitive pricing and bulk supply across India." });

  return (
    <div data-testid="quote-page">
      <PageHero eyebrow="Get Started" title="Request a Wholesale Quote"
        subtitle="Tell us what you need and we'll send a tailored quote within 24 hours." />

      <section className="py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2 space-y-6">
            {[
              { icon: Clock, t: "24-Hour Response", d: "We reply to every enquiry within one business day." },
              { icon: ShieldCheck, t: "No Obligation", d: "Get pricing with zero commitment." },
              { icon: Headset, t: "Dedicated Support", d: "A real person to guide your order." },
            ].map((x) => (
              <Reveal key={x.t}>
                <div className="flex gap-4">
                  <div className="w-11 h-11 rounded-xl bg-forest/10 grid place-items-center text-forest shrink-0"><x.icon size={20} /></div>
                  <div>
                    <h4 className="font-display text-lg text-forest">{x.t}</h4>
                    <p className="text-sm text-muted-foreground">{x.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15} className="lg:col-span-3">
            <div className="bg-cream border border-gold/30 rounded-2xl p-7 shadow-[0_16px_48px_rgba(15,81,50,0.08)]" data-testid="quote-form-card">
              <LeadForm type="quote" fields={["name", "phone", "email", "company", "business_type", "product", "quantity", "message"]} submitLabel="Get My Quote" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
